export class CuaHangBillFormat {
    MaCH: string;
    BillHeader: string;
    BillFooter: string;
    Address: string;
    MST: string;
    phonenumber: string;
    email: string;
    WebSite: string;
    StoreName: string;
}

export class CuaHangFormat {
    MaCH: string;
    TenCH: string;
}

export class QBanCH {
    MaQB: string;
    TenQB: string;
    MaCH: string;
}

export class QuayBanCuaHang {
    MaKhuVuc: string;
    TenCH: string;
    MaCH: string;
    MaQuay: string;
    TenQuay: string;
    CQT_Location: string;
}



export class MaCQT {
  MaKhuVuc: string;
  MaQuay: string;
  Nam: string;
  MaCQT: number;
  TenQuay: string;
  CQT_location: string;
  StoreID: string;
}


export class MaCQT_LuuTru {
  MaKhuVuc: string;
  MaQuay: string;
  Nam: string;
  MaCQT: number;
  TenQuay: string;
  CQT_location: string;
  StoreID: string;
}


export class CuaHang_Store_CTQLocation {
  TillID: string;
  StoreID: string;
  CQT_Location: string;
}

export class TPC_QuayBan_MaCQT {
  Store: string;
  Register: string;
  Year: string;
  MACQT: string;
  Update_Date: string;
  CQT_Location: string;
}

export class Waitbill_MaCQT {
  MaKhuVuc: string;
  MaQuay: string;
  Nam: string;
  MaCQT: number;
  TenQuay: string;
  CQT_location: string;
  StoreID: string;
  HoaDonID: string;
  LoaiHoaDon: number;
}


export class List_MaCQT_SaveOff {
  HDID: string;
  Str_MaCQT: string;
  TillID: string;
}



// WEBPACK FOOTER //
// ./src/app/models/store_stalls.model.ts